var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"xwiki-livedata"},[_c('LivedataAdvancedPanels'),(_vm.translationsLoaded)?_c('LivedataLayout',{attrs:{"layout-id":_vm.layoutId}}):_vm._e(),(_vm.layoutLoaded)?_c('LivedataFootnotes'):_vm._e(),(_vm.data.id)?_c('LivedataPersistentConfiguration'):_vm._e(),(!_vm.layoutLoaded)?_c('div',{staticClass:"loading"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }